import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const buildGoBackBreadcrumbs = (item: CodeComplexValue<number>, breadcrumbs: readonly number[]) => {
  const goBackBreadcrumbs = [...(breadcrumbs ?? [])];

  if (goBackBreadcrumbs.length > 0 && item !== undefined) {
    while (goBackBreadcrumbs[goBackBreadcrumbs.length - 1] && goBackBreadcrumbs[goBackBreadcrumbs.length - 1] !== item.value) {
      goBackBreadcrumbs.pop();
    }
  }

  return goBackBreadcrumbs;
};
